import type { DataProvider } from 'react-admin';

import { fetchQueueStatus } from './fetchQueueStatus';
import type { QueueMetrics } from './types';

interface ShopifySyncDataProvider {
  getList: () => Promise<{ data: QueueMetrics[], total: number }>;
  getOne: () => Promise<never>;
  getMany: () => Promise<never>;
  getManyReference: () => Promise<never>;
  create: () => Promise<never>;
  update: () => Promise<never>;
  updateMany: () => Promise<never>;
  delete: () => Promise<never>;
  deleteMany: () => Promise<never>;
}

const shopifySyncDataProviderImpl: ShopifySyncDataProvider = {
  getList: async () => {
    const queues = await fetchQueueStatus();
    const data = queues.map(queue => ({ ...queue, id: queue.name }));
    return { data, total: data.length };
  },
  getOne: async () => {
    throw new Error('getOne not implemented for shopifySync resource');
  },
  getMany: async () => {
    throw new Error('getMany not implemented for shopifySync resource');
  },
  getManyReference: async () => {
    throw new Error('getManyReference not implemented for shopifySync resource');
  },
  create: async () => {
    throw new Error('create not implemented for shopifySync resource');
  },
  update: async () => {
    throw new Error('update not implemented for shopifySync resource');
  },
  updateMany: async () => {
    throw new Error('updateMany not implemented for shopifySync resource');
  },
  delete: async () => {
    throw new Error('delete not implemented for shopifySync resource');
  },
  deleteMany: async () => {
    throw new Error('deleteMany not implemented for shopifySync resource');
  },
};

// Cast to DataProvider for react-admin compatibility.
// React-admin's DataProvider methods are generic, which prevents type-safe
// single-resource providers. We define proper types above and cast here.
export const shopifySyncDataProvider = shopifySyncDataProviderImpl as unknown as DataProvider;
